import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 update_product_unit_measurement_details: { status: "idle" },
};

export const update_product_unit_measurement_details_Slice = createSlice({
 name: "update_product_unit_measurement_details",
 initialState,
 reducers: {
  success_update_product_unit_measurement_details: (state, action) => {
   state.update_product_unit_measurement_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_product_unit_measurement_details: (state, action) => {
   state.update_product_unit_measurement_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_product_unit_measurement_details: (state) => {
   state.update_product_unit_measurement_details = { status: app_consts.IDLE };
  },
  loading_update_product_unit_measurement_details: (state) => {
   state.update_product_unit_measurement_details = { status: app_consts.LOADING };
  },
 },
});

export const { success_update_product_unit_measurement_details, fail_update_product_unit_measurement_details, reset_update_product_unit_measurement_details, loading_update_product_unit_measurement_details } =
 update_product_unit_measurement_details_Slice.actions;

export default update_product_unit_measurement_details_Slice.reducer;
